<template>
  <div class="news global__fade-in-up">
    <div class="news-listing--heading">
      <slot name="heading" :filter="filterNews"></slot>
    </div>
    <div class="news-listings" ref="listings" aria-live="polite">
      <slot></slot>
    </div>
    <slot name="link" :click="showAll" v-if="!expanded"></slot>
  </div>
</template>

<script>
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { CSSPlugin } from 'gsap/CSSPlugin'

gsap.registerPlugin(ScrollTrigger, CSSPlugin)

export default {
  props: {
    limit: {
      type: Number,
      default: 5,
    },
    filterLimit: {
      type: Number,
      default: 2,
    },
  },
  data() {
    return {
      expanded: false,
      articles: Array,
    }
  },
  mounted() {
    // get all news listings
    this.articles = Array.from(this.$refs.listings.children)
    if (this.articles.length > this.limit) {
      this.applyLimit(this.limit)
    } else {
      this.expanded = true
    }
  },
  methods: {
    filterNews(theme) {
      this.articles.forEach(function(article) {
        // get data-themes attribute and split into array
        var themes = article.dataset.themes.split(',')
        if (themes.includes(theme)) {
          article.style.display = 'flex'
        } else {
          article.style.display = 'none'
        }
      })
      this.applyLimit(this.filterLimit)
    },

    applyLimit(limit) {
      // do not show entire list of articles
      var listings = this.$refs.listings
      var articles = Array.from(listings.children).slice(limit)
      articles.forEach(function(article) {
        article.style.display = 'none'
      })
      // need to call this since the document flow is being modified,
      // and animation positions need to be recalculated
      ScrollTrigger.refresh()
    },

    // TODO: display all for now, later in production should just link to a different page
    showAll() {
      this.articles.forEach(function(article) {
        article.style.display = 'flex'
      })
      // need to call this since the document flow is being modified,
      // and animation positions need to be recalculated
      ScrollTrigger.refresh()
      this.expanded = true
    },
  },
}
</script>
